import { createContext, useState, useEffect } from "react";
import axios from "axios";
import api, { baseURL } from "../services/api";

export const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingApp, setLoadingApp] = useState(true);
  const [loadingAuth, setLoadingAuth] = useState(false);

  // Helper para normalizar o usuário vindo do backend
  function normalizeUser(raw) {
    if (!raw) return null;
    return {
      id: raw.ID ?? raw.id ?? null,
      login: raw.LOGIN ?? raw.login ?? "",
      nome: raw.NOME ?? raw.nome ?? "",
      email: raw.EMAIL ?? raw.email ?? "",
      telefone: raw.TELEFONE ?? raw.telefone ?? "",
      endereco: raw.ENDERECO ?? raw.endereco ?? "",
      cpf: raw.CPF ?? raw.cpf ?? "",
      dataNascimento:
        raw.DATA_NASCIMENTO ?? raw.data_nascimento ?? raw.dataNascimento ?? null,
      photoUrl: raw.PHOTO_URL ?? raw.photo_url ?? raw.photoUrl ?? "",
      dataCriacao:
        raw.DATA_CRIACAO ?? raw.data_criacao ?? raw.dataCriacao ?? null,
      dataAtualizacao:
        raw.DATA_ATUALIZACAO ?? raw.data_atualizacao ?? raw.dataAtualizacao ?? null,
    };
  }

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // Aplica o token tanto no axios global quanto na instância `api`
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api
        .get(`/user/me`)
        .then((res) => {
          setUser(normalizeUser(res.data));
        })
        .catch(() => {
          localStorage.removeItem("token");
          delete axios.defaults.headers.common["Authorization"];
          delete api.defaults.headers.common["Authorization"];
          setUser(null);
        })
        .finally(() => {
          setLoadingApp(false);
        });
    } else {
      setLoadingApp(false);
    }
  }, []);

  async function signIn(login, senha) {
    setLoadingAuth(true);
    try {
      const response = await api.post(`/user/signin`, {
        login,
        senha,
      });
      const { token, user: userData } = response.data;
      localStorage.setItem("token", token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      setUser(normalizeUser(userData));
      setLoadingAuth(false);
      return { success: true };
    } catch (error) {
      setLoadingAuth(false);
      if (error.response) {
        console.error("Login failed", error.response.status, error.response.data);
      } else {
        console.error("Login failed", error.message);
      }
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Erro ao fazer login";
      return { success: false, message };
    }
  }

  async function signUp({ login, senha, nome, email }) {
    setLoadingAuth(true);
    try {
      await api.post(`/user/signup`, {
        login,
        senha,
        nome,
        email,
      });
      await signIn(login, senha);
      setLoadingAuth(false);
      return { success: true };
    } catch (err) {
      setLoadingAuth(false);
      const message = err.response?.data?.message || "Erro ao cadastrar";
      return { success: false, message };
    }
  }

  function signOut() {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser: setUser,
        loadingApp,
        loadingAuth,
        signUp,
        signIn,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
